// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1aQ7Z","label":"Labeled_label__2CtO0","divider":"Labeled_divider__MSHhy"};